<template>
  <v-app id="app" class="application_style">
    <v-navigation-drawer v-if="shouldShowSidebar" app v-model="drawer" permanent>
      <AdminSideMenu :menuItem1="items" :menuItem2="items1" />
    </v-navigation-drawer>
    <v-main class="ex-main-container">
      <div class="main-contant">
        <NotFoundView v-if="getRouteError.code == 404 && getRouteError.visibility == true" />
        <router-view v-if="getRouteError.visibility == false" :key="$route.path" />
      </div>
      <ExLoader v-if="isLoading" text="Loading..." :type="loaderType" />
    </v-main>
    <ToastContainer />
  </v-app>
</template>

<script>
import AdminSideMenu from "@components/AdminSideMenu/AdminSideMenu.vue";
import {
  LD_FLAG_IDEA_MDP_601,
  LD_FLAG_IDEA_MDP_627,
} from "@components/constants/launchDarklyFlagKeys";
import { getKnock } from "@/plugins/knock";
import configService from "./services/config";
import ExLoader from "@components/common/ExLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import NotFoundView from "@components/PageNotFound/NotFound.vue";
import ToastContainer from "@components/ConfirmationToast/ToastContainer.vue";
import { getSystemUsers, getListOfAccounts } from "@/api";
import { isAdminSysadmin } from "@/utils/isAdminSysadmin";

let user = localStorage.getItem("user");
let knockFeed = null;

if (user) {
  user = JSON.parse(user);
  const knock = getKnock();
  if (knock) {
    knock.authenticate(user.email);
    const feedChannelId = configService.get("knockFeedChannelId");
    knockFeed = knock.feeds.initialize(feedChannelId, {
      archived: "exclude",
      page_size: 25,
    });
    knockFeed.listenForUpdates();
    knockFeed.on("items.received.realtime", ({ items }) => {
      console.log(items);
    });
  }
}

export default {
  name: "App",
  components: {
    ExLoader,
    AdminSideMenu,
    NotFoundView,
    ToastContainer,
  },

  async mounted() {
    const LoginAuth = localStorage.getItem("adminToken");
    if (LoginAuth != null) {
      this.fetchAdminCount();
    }
    try {
      if (this.$getFlag) {
        this.onboardingEnabled = await this.$getFlag(LD_FLAG_IDEA_MDP_601, true);
        this.adoptionScoringEnabled = await this.$getFlag(LD_FLAG_IDEA_MDP_627, false);
      }
    } catch (error) {
      console.error("Error resolving Onboarding nav flag:", error);
    }
  },

  methods: {
    async fetchAdminCount() {
      try {
        const { data: userList } = await getSystemUsers({
          page: 1,
          size: 1,
          limit: 1,
          offset: 0,
          status: "operational",
        });
        const { data: accountsList } = await getListOfAccounts({
          limit: 1,
          offset: 0,
          status: "open",
        });

        const activeUserCount = Number(userList.count) || 0;

        const activeAccountCount = Number(accountsList.count) || 0;
        this.$store.commit("setActiveUserCount", activeUserCount);
        this.$store.commit("setActiveAccountCount", activeAccountCount);
      } catch (error) {
        console.error("Error fetching admin counts:", error);
      }
    },
  },

  data: () => ({
    drawer: true,
    onboardingEnabled: true,
    adoptionScoringEnabled: false,
    // items: [
    //   {
    //     title: "Accounts",
    //     icon: require("./assets/sidebar/account-icon.svg"),
    //     count: localStorage.getItem("active_accounts_count") || 0,
    //     to: "/accounts",
    //   },
    //   {
    //     title: "Subscriptions",
    //     icon: require("./assets/sidebar/subscription-icon.svg"),
    //     count: 0,
    //     to: "/subscriptions",
    //   },
    //   {
    //     title: "Users",
    //     icon: require("./assets/sidebar/user-Icon.svg"),
    //     count: 0,
    //     to: "/users",
    //   },
    //   {
    //     title: "Partners",
    //     icon: require("./assets/sidebar/partners-icon.svg"),
    //     count: 0,
    //     to: "#",
    //   },
    // ],
  }),
  computed: {
    getRouteError() {
      return this.$store.state.routeErrorHandling.error;
    },
    isLoading() {
      return this.$store.state.isLoading.isLoading;
    },
    loaderType() {
      return this.$store.state.isLoading.loaderType;
    },
    shouldShowSidebar() {
      return this.$route.meta.sidebar !== false;
    },
    isSuperUser() {
      // ER-12719: admin-login proves sysadmin even if login payload omits is_superuser.
      return isAdminSysadmin();
    },
    items1() {
      // ER-12307 — Settings is a platform-level nav group. The only destination today
      // is the Adoption scoring page, gated behind idea-MDP-627 and super-user access.
      if (!this.adoptionScoringEnabled || !this.isSuperUser) {
        return [];
      }
      return [
        {
          title: "Settings",
          icon: require("@components/assets/side-bar/settings.svg"),
          to: "/settings/adoption-scoring",
        },
      ];
    },
    activeUserCount() {
      return this.$store.getters.activeUserCount;
    },
    items() {
      const navItems = [
        {
          title: "Accounts",
          icon: require("@components/assets/side-bar/Company with Employees-grey.svg"),
          count: this.$store.getters.activeAccountCount, // Computed dynamically
          to: "/accounts",
        },
        {
          title: "Subscriptions",
          icon: require("@components/assets/side-bar/Subscription-grey.svg"),
          count: 0,
          to: "/subscriptions",
        },
        {
          title: "Users",
          icon: require("@components/assets/side-bar/users-01.svg"),
          count: this.$store.getters.activeUserCount, // Computed dynamically
          to: "/users",
        },
        {
          title: "Partners",
          icon: require("@components/assets/side-bar/Partnership-grey.svg"),
          count: 0,
          to: "#",
        },
      ];

      // MDP-601 / ER-11480 — "Onboarding" is a new top-level nav item (flat link).
      // Kill-switch: rendered by default; set idea-MDP-601 to false in LaunchDarkly
      // to hide it (e.g. until its destination page is confirmed).
      if (this.onboardingEnabled) {
        navItems.push({
          title: "Onboarding",
          icon: require("@components/assets/side-bar/Onboarding.svg"),
          count: 0,
          to: "/onboarding",
        });
      }

      return navItems;
    },
  },
  watch: {
    activeUserCount(newCount) {
      const userItem = this.items.find((item) => item.title === "Users");
      if (userItem) {
        userItem.count = newCount;
      }
    },
    $route(to, from) {
      const publicPages = new Set([
        "/login",
        "/forgot-password",
        "/setup/password",
        "/reset/password",
      ]);
      const comingFromPublicPage = publicPages.has(from.path);
      const goingToPrivatePage = !publicPages.has(to.path);
      if (comingFromPublicPage && goingToPrivatePage) {
        const loginAuth = localStorage.getItem("adminToken");
        if (loginAuth) {
          this.fetchAdminCount();
        }
      }
    },
  },
};
</script>
<style>
.v-main__wrap {
  display: flex;
}
.application_style {
  font-family: "Inter", sans-serif !important;
}
.main-contant {
  width: 100%;
  height: 100%;
  padding: 15px;
}
.main-contant section {
  height: 100%;
}
.ex-main-container {
  scrollbar-width: none;
}
</style>
